import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Navbar from "./guidwell/components/Navbar";
import Footer from "./guidwell/components/Footer";
import PrivacyPolicy from "./guidwell/components/PrivacyPolicy";
import TermOfService from "./guidwell/components/TermsOfService";
import ScrollToTop from "./guidwell/components/ScrollToTop";
import LandingPage from "./guidwell/components/LandingPage";

/* Wraps pages that need the top Navbar (Privacy, Terms) */
function NavLayout({ children }) {
  return (
    <>
      <Navbar />
      <div style={{ paddingTop: '72px' }}>{children}</div>
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<NavLayout><PrivacyPolicy /></NavLayout>} />
        <Route path="/terms-of-service" element={<NavLayout><TermOfService /></NavLayout>} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
